import { getReceiveMessageListCount, notificationCount } from '@/api/messageCenter/index'
const messageCountStore = () => {
    const notiyCount = ref(0)
    const boradCount = ref(0)

    const getBoradCount = async () => {
        const { data } = await getReceiveMessageListCount()
        boradCount.value = data || 0
    }

    const getNotiyCount = async () => {
        const { data } = await notificationCount()
        notiyCount.value = data || 0
    }

    const refreshMessageCount = async () => {
        await Promise.all([getBoradCount(), getNotiyCount()])
    }

    const totalCount = computed(() => {
        return notiyCount.value + boradCount.value
    })

    return {
        notiyCount,
        boradCount,
        totalCount,
        getBoradCount,
        getNotiyCount,
        refreshMessageCount
    }
}

export const useMessageCountStore = defineStore('MessageCountStore', messageCountStore)